/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { BaseIconButton, Props as BaseIconButtonProps } from './BaseIconButton';

export type Props = BaseIconButtonProps & {
  color?: 'icon-primary' | 'icon-alt' | 'icon-secondary';
};

/**
 * `IconButton`s are `Buttons` that render `Icon`s within them for
 * compact spaces. They accept most props that `Button` accepts, although
 * they'll always be `isSquare={true}`. Additionally, `IconButton` renders
 * a `Tooltip` which describes what the `Button` does, which is important
 * for accessibility.
 */
export function IconButton({
  color = 'icon-primary',
  size = 'small',
  tooltipPosition = 'south',
  ...props
}: Props) {
  return (
    <BaseIconButton
      color={color}
      size={size}
      tooltipPosition={tooltipPosition}
      {...props}
    />
  );
}
